import React from 'react';
import { cn } from '../../utils/cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'glass' | 'solid' | 'interactive';
}

export const Card: React.FC<CardProps> = ({ className, variant = 'glass', children, ...props }) => {
  const variants = {
    glass: 'bg-[#0f1b2d]/80 border border-[#4a82c2]/20 backdrop-blur-xl shadow-2xl shadow-black/30 rounded-2xl',
    solid: 'bg-[#0f1b2d] border border-slate-800 shadow-md rounded-2xl',
    interactive: 'bg-[#0f1b2d]/80 border border-[#4a82c2]/20 backdrop-blur-xl shadow-2xl shadow-black/30 rounded-2xl transition-all duration-300 hover:-translate-y-1.5 hover:border-[#4a82c2]/60 hover:shadow-2xl hover:shadow-[#4a82c2]/15',
  };

  return (
    <div className={cn(variants[variant], className)} {...props}>
      {children}
    </div>
  );
};

export const CardHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...props }) => (
  <div className={cn('p-6 pb-4', className)} {...props}>
    {children}
  </div>
);

export const CardTitle: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({ className, children, ...props }) => (
  <h3 className={cn('text-xl font-bold text-white tracking-tight', className)} {...props}>
    {children}
  </h3>
);

export const CardContent: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...props }) => (
  <div className={cn('p-6 pt-0', className)} {...props}>
    {children}
  </div>
);

export const CardFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, children, ...props }) => (
  <div className={cn('p-6 pt-0 flex items-center', className)} {...props}>
    {children}
  </div>
);
